module.exports = __webpack_public_path__ + "img/pendiente_b.e260c957.png";